import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import GuestsPage from "./pages/GuestsPage";
import RoomsPage from "./pages/RoomsPage";
import PaymentsPage from "./pages/PaymentsPage";
import BookingsPage from "./pages/BookingsPage";
import AccountsPage from "./pages/AccountsPage";
import KassePage from "./pages/KassePage";
import SettingsPage from "./pages/SettingsPage";
import BlacklistPage from "./pages/BlacklistPage";
import WohnungenPage from "./pages/WohnungenPage";
import BankumsaetzePage from "./pages/BankumsaetzePage";
import Layout from "./components/Layout";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-slate-900"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="guests" element={<GuestsPage />} />
        <Route path="rooms" element={<RoomsPage />} />
        <Route path="wohnungen" element={<WohnungenPage />} />
        <Route path="bookings" element={<BookingsPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="accounts" element={<AccountsPage />} />
        <Route path="kasse" element={<KassePage />} />
        <Route path="bankumsaetze" element={<BankumsaetzePage />} />
        <Route path="blacklist" element={<BlacklistPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
